export const FixedVAT = 0.19

const VAT_RATES = {
    DE: 0.19,
    AT: 0.2,
    FR: 0.2,
    IT: 0.22
}

export const calculateVAT = (
    price: number,
    country = 'DE'
): {
    value: string
    percentage: number
} => {
    const vatRate = VAT_RATES[country as keyof typeof VAT_RATES] || FixedVAT

    // formula for calculating VAT
    const parsedVat = ((price * vatRate) / (1 + vatRate)).toFixed(2)

    return {
        value: parsedVat,
        percentage: vatRate * 100 || FixedVAT * 100
    }
}
